import { FormEvent, useEffect, useState } from 'react';
import { useAddressIsNotValidMutation, useAddressIsValidMutation, useGetAnzahlBeiAdresseMutation, useStorniereAuftragMutation, useUnpinnAuftragMutation } from '../../api/AuftragAPI';
import { IAuftrag } from '../../types/Types';
import { formatToEuroDate, formatToEuroDateTime } from '../../util/DateUtils';
import AuftragTerminAendernComponent from '../AuftragTerminAendernComponent/AuftragTerminAendernComponent';
import AuftragWiedervorlageComponent from '../AuftragWiedervorlageComponent/AuftragWiedervorlageComponent';
import AuftragDeckblattDownloadComponent from '../buttons/AuftragDeckblattDownloadComponent';
import HinweisComponent from '../HinweisComponent';
import HistorieComponent from '../HistorieComponent';
import UploadToServer from '../UploadComponent/UploadToServer';
import Styles from './auftragterminierencomponent.module.scss';
import AuftragTerminierenDienstleistungenComponent from './UploadComponent/AuftragTerminierenDienstleistungenComponent';
import ButtonCopyComponent from '../buttons/ButtonCopyComponent';

export type IAuftragsdaten = {
  stunde: string,
  minute: string,
  wiedervorlagetage: string,
  terminierungFertig: boolean,
  termindatum: string,
}

interface ThisProps {
  statusChanged: () => void;
  changeColor: (auftraguid: string, color: string) => void;
  centerOnMap: (id: string) => void;
  numberOnMap: number,
  propsAuftrag: IAuftrag,
}

/**
 * @author noone
 */
const AuftragTerminierenComponent: React.FC<ThisProps> = ({ statusChanged, changeColor, centerOnMap, numberOnMap, propsAuftrag }) => {

  const [getAnzahlBeiAdresse] = useGetAnzahlBeiAdresseMutation();
  const [unpinnAuftragAPI] = useUnpinnAuftragMutation();
  const [stornoAuftragAPI] = useStorniereAuftragMutation();
  const [addressIsValidAPI] = useAddressIsValidMutation();
  const [addressIsNotValidAPI] = useAddressIsNotValidMutation();

  const [auftrag, setAuftrag] = useState<IAuftrag>(propsAuftrag);

  const [auftraegeInDerNaehe, setAuftraegeInDerNaehe] = useState<string[]>([]);

  const [subAnzeige, setSubAnzeige] = useState<string>("info");
  const [color, setColor] = useState<string>(auftrag.colorAuftrag || "#3B3B3B");


  const stornoAuftrag = (uid: string) => {
    stornoAuftragAPI(uid).unwrap()
      .then(() => statusChanged())
      .catch((error) => { console.log(error) })
      ;
  }

  const unpinnAuftrag = async () => {
    unpinnAuftragAPI(auftrag.uid).unwrap()
      .then(() => setAuftrag(prev => ({ ...prev, angepinnt: false })))
      .catch((e) => console.log("" + e));
  }

  const formatiereMesszeitpunkt = (messzeitpunkt: string) => {
    const split = messzeitpunkt.split("_");
    if (split.length === 0) return "k.A.";
    var mzp = "";
    if (split.length > 0) {
      if (split[0] === "1")
        mzp += "Neu";
      else if (split[0] === "2")
        mzp += "Sanierung";
      else if (split[0] === "3")
        mzp += "Bestand";
      else
        mzp += "k.A.";
    }

    if (split.length > 1) {
      if (split[1] === "sofort")
        mzp += " - Sofort";
      else if (split[1] === "nach_putz")
        mzp += " - Nach Putz";
      else if (split[1] === "nach_estrich")
        mzp += " - Nach Estrich";
      else if (split[1] === "eilig")
        mzp += " - Eilig (Unterlagen zurück bis zum " + formatToEuroDate(auftrag.spaetmesstermin) + ")";
      else
        mzp += "";
    }
    return mzp;
  }

  useEffect(() => {
    changeColor(auftrag.uid, color);
  }, [color]);

  const handleAddressValidClick = (e: React.MouseEvent<HTMLInputElement>) => {
    e.preventDefault();

    if (auftrag?.addressValid) {
      addressIsNotValidAPI(auftrag.uid).unwrap()
        .then(() => setAuftrag(prev => ({ ...prev, addressValid: false })))
        .catch((e) => console.log("" + e));
    } else {
      addressIsValidAPI(auftrag.uid).unwrap()
        .then(() => setAuftrag(prev => ({ ...prev, addressValid: true })))
        .catch((e) => console.log("" + e));
    }
  }

  useEffect(() => {

    //
    getAnzahlBeiAdresse(auftrag.uid).unwrap()
      .then((data) => {
        setAuftraegeInDerNaehe(data);
      });

  }, []);

  return (
    <>
      <div className={Styles.auftragCardWrapper} id={"number" + numberOnMap + "Auftrag"}>

        <div className={Styles.auftragCardHeader} >

          <div onClick={() => document.getElementById("colorinput_" + numberOnMap)?.click()} className={Styles.badge} style={{ background: (color.length === 7) ? color : "#" + color, color: "white" }}>{numberOnMap}</div>

          <input
            id={"colorinput_" + numberOnMap}
            type="color"
            value={(color.length === 7) ? color : "#" + color}
            onChange={(e) => setColor(e.target.value)}
            style={{ visibility: "hidden", position: "absolute" }}
          />

          {auftrag?.angepinnt &&
            <div>
              <i onClick={() => { unpinnAuftrag() }} style={{ color: "black", fontSize: "2rem", cursor: "pointer" }} className="bi bi-pin-fill"></i>
            </div>
          }

          <div className={Styles.info}>
            <div className={Styles.title}>
              {auftrag?.stadt_lieferadresse} - {auftrag?.name_endkunde} {auftrag?.vorname_endkunde}
            </div>
            <div className={Styles.date}>erstellt am {formatToEuroDateTime(auftrag.createDate)}</div>
          </div>

          <div className={Styles.actions}>
            <button
              className="btn"
              onClick={(event: FormEvent) => {
                event.stopPropagation();
                centerOnMap(auftrag.uid);
              }} ><i className='bi bi-geo-alt'></i></button>
            <button
              className="btn"
              onClick={(event: FormEvent) => {
                event.stopPropagation();
                window.open(
                  "./.auftragdetails?uid=" + auftrag?.uid + "&backbuttonClose=true",
                  "_blank"
                );
              }} ><i className='bi bi-pencil-fill'></i></button>

          </div>
        </div>

        <div className={Styles.auftragCardContent}>
          <div>

            <AuftragDeckblattDownloadComponent uidAuftrag={auftrag.uid} />

            <div className="card" style={{ marginTop: "1em", padding: "1em" }}>

              <ButtonCopyComponent textToCopy={""
                + auftrag?.strasse_lieferadresse + " "
                + auftrag?.hausnummer_lieferadresse + "\n"
                + auftrag?.postleitzahl_lieferadresse + " "
                + auftrag?.stadt_lieferadresse} />

              <br />{auftrag?.vorname_endkunde} {auftrag?.name_endkunde}
              <br />{auftrag?.strasse_lieferadresse} {auftrag?.hausnummer_lieferadresse}
              <br />{auftrag?.postleitzahl_lieferadresse} {auftrag?.stadt_lieferadresse}

              <div style={{ display: "grid", gridTemplateColumns: "auto auto", alignItems: "center", gap: "0.5em", marginTop: "0.5em" }}>
                <div>
                  <label className="form-check-label" htmlFor="adresseValid">
                    Adresse Valid:
                  </label>
                </div><div>
                  <input type="checkbox" checked={auftrag?.addressValid} onClick={handleAddressValidClick} />
                </div>
              </div>

              <p>
                <br />Art: {auftrag?.art}
                <br />Messzeitpunkt: {formatiereMesszeitpunkt(auftrag?.messzeitpunkt)}
                <br />Nr. Aufträge hier: <span style={{ backgroundColor: (auftraegeInDerNaehe.length !== 1) ? "red" : "white", border: "1px solid black", padding: "3pt", borderRadius: "5px" }}>{auftraegeInDerNaehe.length}</span>
                <br />Mobil1: {auftrag?.mobil1_lieferadresse}
                <br />Mobil2: {auftrag?.mobil2_lieferadresse}
                <br />Telefon: {auftrag?.telefon_lieferadresse}
                <br />Email: {(auftrag?.email_lieferadresse) ? <a href={`mailto:${auftrag?.email_lieferadresse ?? ''}`}>{auftrag?.email_lieferadresse}</a> : ""}
                <br />Name AP: {auftrag?.name_ansprechpartner}
                <br />Kontakt AP: {auftrag?.kontakt_ansprechpartner}
                <br />Email AP: {(auftrag?.email_ansprechpartner) ? <a href={`mailto:${auftrag?.email_ansprechpartner ?? ''}`}>{auftrag?.email_ansprechpartner}</a> : ""}
              </p>

              <p>Hinweise zum Aufmaß und Messzeitpunkt: {auftrag?.besonderheiten} </p>

            </div>
          </div>

          <div>

            <ul className="nav nav-pills">
              <li className="nav-item" style={{ cursor: "pointer" }}>
                <a className={`nav-link ${subAnzeige === "info" ? "active" : ""}`} aria-current="page" onClick={() => setSubAnzeige("info")}>Info</a>
              </li>
              <li className="nav-item" style={{ cursor: "pointer" }}>
                <a className={`nav-link ${subAnzeige === "hinweise" ? "active" : ""}`} onClick={() => setSubAnzeige("hinweise")}>Hinweise</a>
              </li>
              <li className="nav-item" style={{ cursor: "pointer" }}>
                <a className={`nav-link ${subAnzeige === "aktion" ? "active" : ""}`} aria-current="page" onClick={() => setSubAnzeige("aktion")}>Aktion</a>
              </li>
              <li className="nav-item" style={{ cursor: "pointer" }}>
                <a className={`nav-link ${subAnzeige === "historie" ? "active" : ""}`} onClick={() => setSubAnzeige("historie")} >Historie</a>
              </li>
              <li className="nav-item" style={{ cursor: "pointer" }}>
                <a className={`nav-link ${subAnzeige === "dateien" ? "active" : ""}`} onClick={() => setSubAnzeige("dateien")} >Dateien</a>
              </li>
              <li className="nav-item" style={{ cursor: "pointer" }}>
                <a className={`nav-link ${subAnzeige === "dienstleistungen" ? "active" : ""}`} onClick={() => setSubAnzeige("dienstleistungen")} >Dienstleistungen</a>
              </li>
            </ul>

            {subAnzeige === "info" &&
              <div className="card" style={{ marginTop: "1em", padding: "1em" }}>
                Auftraggeber: {(auftrag?.auftraggeber != null) ? auftrag?.auftraggeber.name : "k.A."}<br />
                Bearbeiter: {(auftrag?.bearbeiter != null) ? auftrag?.bearbeiter.name : "k.A."}<br />
                Erstellt von: {auftrag?.erstelltVon.name}<br />
                Erstellt am: {formatToEuroDateTime(auftrag.createDate)}<br />
                Spätmögl. Termin: {formatToEuroDate(auftrag?.spaetmesstermin)} <br />
                {(auftrag?.name_ansprechpartner) ? <span>Ansprechpartner: {auftrag?.name_ansprechpartner}</span> : <span>Keine Ansprechpartner</span>}
                {(auftrag?.email_lieferadresse) ? <span>Email an Lieferadresse: <a href={`mailto:${auftrag?.email_lieferadresse ?? ''}`}>{auftrag?.email_lieferadresse}</a></span> : <span>Keine Lieferadressenemail vorhanden</span>}
                {(auftrag?.email_ansprechpartner) ? <span>Email an Ansprechpartner: <a href={`mailto:${auftrag?.email_ansprechpartner ?? ''}`}>{auftrag?.email_ansprechpartner}</a></span> : <span>Keine Ansprechpartneremail vorhanden</span>}
              </div>}

            {subAnzeige === "aktion" &&
              <>
                <div className="card" style={{ marginTop: "1em", padding: "1em" }}>

                  <AuftragWiedervorlageComponent uid_auftrag={auftrag.uid} statusChanged={statusChanged} />

                  <div style={{ marginTop: "1em" }}></div>

                  <AuftragTerminAendernComponent uid_auftrag={auftrag.uid} statusChanged={statusChanged} />

                  <div style={{ marginTop: "1em" }}></div>

                  <button
                    className="btn btn-danger"
                    onClick={() => { if (window.confirm('Bist du sicher?')) { stornoAuftrag(auftrag.uid); } }} ><i className='bi bi-trash'></i> Stornieren</button>
                </div>
              </>}

            {subAnzeige === "hinweise" &&
              <>
                <div className="card" style={{ marginTop: "1em", padding: "1em" }}>
                  <HinweisComponent auftragUid={auftrag.uid} />
                </div>
              </>}

            {subAnzeige === "historie" &&
              <>
                <div className="card" style={{ marginTop: "1em", padding: "1em" }}>

                  Historie

                  <HistorieComponent auftragUid={auftrag.uid} />

                </div>
              </>}

            {subAnzeige === "dateien" &&
              <>
                <div>
                  <h4>Dateien</h4>
                  <UploadToServer uid={auftrag?.uid ?? ''} />
                </div>
              </>}

            {subAnzeige === "dienstleistungen" &&
              <>
                <div>
                  <AuftragTerminierenDienstleistungenComponent uid={auftrag?.uid ?? ''} />
                </div>
              </>}

          </div>
        </div>
      </div>
    </>
  );

}

export default AuftragTerminierenComponent;